module.exports = __webpack_public_path__ + "static/media/email.e6956db2.svg";